import { LAYOUT_LIST, QUIZ_CHOICE } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { CardHelper } from '~/training/sequence/templates/translators/itemHelpers/CardHelper';
import { ItemOfType } from '~/training/sequence/templates/translators/itemHelpers/types';
import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';

export const Quiz8: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(item as ItemOfType<'Question'>, {
              width: '370px',
              height: 'auto',
              align: 'left',
              padding: '0px',
              extraItems: [
                {
                  type: QUIZ_CHOICE,
                  id: item.id,
                  values: {
                    variant: item.items && item.items.length > 2 ? 'list' : '',
                    title: item?.title?.includes('?')
                      ? item.title
                      : item?.body?.includes('?')
                      ? item.body
                      : '',
                    length: item?.items?.length,
                    multiSelect: item?.items?.filter(
                      item => item.correct === true
                    ).length
                  },
                  items: AnswerButtonHelper(
                    item.id,
                    item.items,
                    undefined,
                    item.llamaSurvey,
                    item.title || ''
                  )
                }
              ]
            })
          ]
        };
      default:
        return null;
    }
  });
};
